export const POPUP_MOUNTPOINT = 'twp-dropbox-popup-mount-point';
export const DROPBOX_IFRAME_NAME = 'twp-dropboxjs-iframe';
